import React, { createContext, Reducer, useReducer } from 'react';

export type MfaState = {
	mfaInitialized: boolean;
	phoneFactor?: {
		id: string;
		value: string;
	}
}

export type Actions = SetPhoneFactor | Initialized;

export type SetPhoneFactor = MfaState['phoneFactor'] & {
	type: 'setPhoneFactor';
}

export type Initialized = {
	type: 'initialized';
}

export type RawMfaFactor = {
	id: string;
	name: string;
	oob_channel: 'sms';
}

const Dispatch = createContext<React.Dispatch<Actions>>(() => {});
const State = createContext<MfaState>({
	mfaInitialized: false
});

const reducer: Reducer<MfaState, Actions> = (state, action) => {
	switch (action.type) {
		case 'initialized':
			return {
				...state,
				mfaInitialized: true
			};

		case 'setPhoneFactor':
			return {
				...state,
				phoneFactor: {
					id: action.id,
					value: action.value
				}
			};

		default:
			throw new Error('Invalid action type in MFA reducer');
	}
}

function Provider({ children }: { children: JSX.Element[] | JSX.Element }) {
	const [state, dispatch] = useReducer(reducer, {
		mfaInitialized: false
	});

	// The state and the dispatch function should be provided separately so that components that are interested
	// only in dispatching events don't need to use the state and thus re-render when the state changes
	// See here - https://reactjs.org/docs/hooks-faq.html#how-to-avoid-passing-callbacks-down
	return (
		<State.Provider value={state}>
			<Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
		</State.Provider>
	)
}

export const MfaFactors = {
	State,
	Dispatch,
	Provider
};